<template>
  <div>
    <div class="settings relative mt-80">
      <div class="grid-full flex flex-h-bet">
        <div class="flex table-tab">
          <router-link
            class="table-tab-item"
            v-for="(link, i) in links"
            :key="i"
            :to="link.url"
            :class="{ disabled: link.disabled }"
            :tabindex="link.disabled ? -1 : 0"
            @click.prevent="link.disabled ? null : $router.push(link.url)"
          >
            {{ link.label }}
          </router-link>
        </div>
        <router-link
          v-if="settings"
          :to="settings"
          class="move-right grid-full black no-line"
        >
          <div class="settings-bg">
            <img src="/img/settings-b.svg" alt="settings" />
            <span>Settings</span>
          </div>
        </router-link>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ["links", "settings"],
};
</script>

<style scoped>
.mt-80 {
  margin-top: 80px;
}
.table-tab-item.disabled {
  pointer-events: none;
  color: #ccc;
}

/* Responsive styles */
@media (max-width: 900px) {
  .settings.relative.mt-80 {
    margin-top: 40px;
  }
  .grid-full.flex.flex-h-bet {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  .table-tab {
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-start;
  }
  .move-right.grid-full.black.no-line {
    align-self: flex-end;
    margin-left: 0;
    margin-top: 10px;
    width: fit-content;
  }
}

@media (max-width: 600px) {
  .settings.relative.mt-80 {
    margin-top: 20px;
  }
  .table-tab {
    flex-direction: column;
    align-items: stretch;
    gap: 4px;
  }
  .table-tab-item {
    width: 100%;
    text-align: left;
    padding: 8px;
  }
  .settings-bg {
    flex-direction: row;
    align-items: center;
    gap: 6px;
  }
}
</style>
